export default  {
    notificationApiUrl: process.env.VUE_APP_NotificationAPIBaseURL,
    questionnaireUrl: process.env.VUE_APP_QuestionnaireURL,
    fmrtqApiUrl: process.env.VUE_APP_FmrtqApiUrl,
    esgPortalUrl: process.env.VUE_APP_EsgPortalUrl,
    apiKey: process.env.VUE_APP_API_KEY
}